module.exports = __webpack_public_path__ + "img/DVlogo.be4dd880.svg";